<template>
  <div style="height: 100%; width: 100%;" v-loading="loading">
    <span v-if="!loading">
      <el-menu
        :default-active="'/admin/eventsbytype/'+(this.$router.currentRoute.params.eventTypeId ? this.$router.currentRoute.params.eventTypeId : this.eventTypes[0].o_id)"
        :router="true"
        mode="horizontal"
      >
        <el-menu-item
          v-for="type in this.eventTypes"
          :key="type.o_id"
          :index="'/admin/eventsbytype/'+type.o_id"
        >{{type.name}}</el-menu-item>
      </el-menu>
      <div style="margin: 16px; display: flex; justify-content: center;">
        <router-view></router-view>
      </div>
    </span>
  </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            eventTypes: []
        };
    },
    created() {
        if (!this.$store.getters.hasPermission(["Records", "EventScanning"]))
            this.$router.push("/admin");
    },
    mounted() {
        this.getEventTypes();
    },
    methods: {
        getEventTypes() {
            this.axios
                .get("/api/v1/eventtypes", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.eventTypes = response.data;
                    this.loading = false;
                    if (!this.$router.currentRoute.params.eventTypeId) {
                        this.$router.push("/admin/eventsbytype/" + this.eventTypes[0].o_id);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        }
    }
};
</script>
